import moment from 'moment'
import styled from 'styled-components'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  @media only screen and (max-width: 600px) {
    align-items: flex-start;
  }
`

const Start = styled.div`
  font-size: 44px;
  font-weight: 900;
  line-height: 1;
  text-transform: uppercase;
  color: var(--date-text);
  text-align: right;
  @media only screen and (max-width: 720px) {
    font-size: 32px;
  }
  @media only screen and (max-width: 600px) {
    display: flex;
    align-items: center;
    font-size: 18px;
    text-align: left;
  }
`

const Day = styled.div`
  font-size: 100px;
  font-weight: 900;
  @media only screen and (max-width: 720px) {
    font-size: 72px;
  }
  @media only screen and (max-width: 600px) {
    font-size: 46px;
    margin-right: 10px;
  }
`

const Year = styled.div`
  opacity: 0.6;
  letter-spacing: 1px;
`

const End = styled.div`
  font-size: 21px;
  font-weight: 900;
  line-height: 1;
  text-transform: uppercase;
  color: var(--date-text);
  text-align: right;
  opacity: 0.6;
  @media only screen and (max-width: 720px) {
    font-size: 16px;
  }
  @media only screen and (max-width: 600px) {
    font-size: 14px;
    margin: 10px 0 14px;
  }
`

const Divide = styled.div`
  width: 40px;
  height: 3px;
  margin: 20px 0;
  background: var(--date-text);
  opacity: 0.6;
  border-radius: 4px;
  @media only screen and (max-width: 600px) {
    display: none;
  }
`

// biome-ignore lint/correctness/noUnusedFunctionParameters: TODO
const HeroDate = ({ dateEnd, dateStart, timezone }) => {
  const startDay = moment(dateStart).format('DD')
  const starMonth = moment(dateStart).format('MMMM')
  const startYear = moment(dateStart).format('YYYY')
  const endDay = moment(dateEnd).format('Do')
  const endMonth = moment(dateEnd).format('MMM')
  const endYear = moment(dateEnd).format('YYYY')

  return (
    <Wrapper>
      <Start>
        <Day>{startDay}</Day>
        <div className="month-year">
          <div>{starMonth}</div>
          <Year>{startYear}</Year>
        </div>
      </Start>
      <Divide />
      <End>
        - {endDay} {endMonth}, {endYear}
      </End>
    </Wrapper>
  )
}

export default HeroDate
